import axios from 'axios';
import { API_URL } from './api';

export const installationsService = {
    getAll (configuration) {
        console.log('installationsService: getAll', configuration.current);

        return axios
            .get(`${API_URL}/installations`)
            .then((response) => {
                if (response.data.list)
                {
                    return response.data.list;
                }

                return response;
            });
    },
};

export default installationsService;
